module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; __append("<div class=\"prop-header\"><span class=\"prop-label\">Frame</span></div>\r\n<div class=\"row prop-detail\">\r\n\r\n    <div class=\"row\">\r\n        <div class=\"col-md-6 nopadding-r form-group-flex\">\r\n            <input type=\"checkbox\" name=\"frame\" id=\"frame\" class=\"form-radio-group\"/>\r\n            <label for=\"frame\" class=\"form-group-label\">Show a Frame</label>\r\n        </div>\r\n        <div class=\"isFrameActive\">\r\n            <div class=\"col-md-6 subsection\" >\r\n                <label class=\"prop-sublabel label-35\">Width</label>\r\n                <div>\r\n                    <input type=\"text\" name=\"frameSize\" value=\"")
    ; __append(escapeFn(frameSize))
    ; __append("\" style=\"width: 35px;\" />&nbsp;px\r\n                </div>\r\n            </div>\r\n        </div>\r\n    </div>\r\n\r\n    <div class=\"row isFrameActive\">\r\n        <div class=\"col-md-6 subsection nopadding-r\"> \r\n            <label class=\"prop-sublabel label-35\">Color</label>\r\n            <div style=\"margin-right: -15px;\">\r\n                <input id=\"frameColorPicker\" name=\"frameColor\" type=\"color\" value=\"")
    ; __append(escapeFn( frameColor ))
    ; __append("\" style=\"width: 20px; border: 1px solid #aaaaaa; padding: 0px; height: 23px;\" />\r\n                <input id=\"frameColor\" name=\"frameColor\" type=\"text\" maxlength=\"7\" class=\"color-picker-text\" value=\"")
    ; __append(escapeFn( frameColor ))
    ; __append("\" />\r\n            </div>\r\n        </div>\r\n        <div class=\"col-md-6 prop-sublabel form-group-flex nopadding-r\">\r\n            <input type=\"checkbox\" name=\"frameRoundCorners\" id=\"frameRoundCorners\" class=\"form-radio-group\"/>\r\n               <label class=\"form-group-label\">Round Corners</label>\r\n        </div>\r\n    </div>\r\n      \r\n</div>")
  }
  return __output;

}